import React from 'react';

interface FormatCellsIconProps {
    width?: string | number;
    height?: string | number;
}

// Sheet editor toolbar "Format cells" icon — inherits the toolbar's own text
// colour (no `colour` prop) via `stroke="currentColor"`.
const FormatCellsIcon = ({ width = 16, height = 16 }: FormatCellsIconProps) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2.5" width="12" height="11" rx="1" stroke="currentColor" strokeWidth="1.2" />
        <path d="M2 6.5h12M6.5 6.5v7" stroke="currentColor" strokeWidth="1.2" />
    </svg>
);

export default FormatCellsIcon;
